import React from 'react';
import { scrollableBox } from '../style';
import { Box } from '@mui/material';
interface ScrollableBoxProps {
  children: React.ReactNode;
 
}

const ScrollableBox: React.FC<ScrollableBoxProps> = ({
  children,

}) => {
  return (
    <Box sx={scrollableBox.wrapper}
    >
      {children}
    </Box>
  );
};

export default ScrollableBox;